export const rules = {
  profession: { required: true, message: '必填项', trigger: 'blur' },
  business: { required: true, message: '必填项', trigger: 'blur' },
  store: { required: true, message: '必填项', trigger: 'blur' },
  td: { required: true, message: '必填项', trigger: 'blur' },
  to: { required: true, message: '必填项', trigger: 'blur' },
  tp_type: { required: true, message: '必填项', trigger: 'blur' },
  // tp_every: { required: true, message: '必填项', trigger: 'blur' },
  // tp_day: { required: true, message: '必填项', trigger: 'blur' },
  // tp_date: { required: true, message: '必填项', trigger: 'blur' },
  tv1: { required: true, message: '必填项', trigger: 'blur' },
  tv2: { required: true, message: '必填项', trigger: 'blur' },
  ti: { required: true, message: '必填项', trigger: 'blur' }
}



export const radioList = [

]



// WEBPACK FOOTER //
// ./src/views/statistics/supply/data.js